import styled from 'styled-components';
import { Link } from '@/components/Link';

export const Footer = styled.footer`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--spacing-large);
  padding: var(--spacing-large);
  border-block-start: 1px solid var(--grey-100);

  @media (width >= 57rem) {
    max-width: 444px;
  }
`;

export const FooterLink = styled(Link)`
  font-size: var(--font-size-text-sm);
  line-height: 1.5;
`;
